import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import { DCAR_APP_CONFIG } from 'app/app-config.service';
import { fixPrimeNgAutofocus } from 'app/theme/primeng-autofocus-fix';

if (environment.production) {
    enableProdMode();
}

fixPrimeNgAutofocus();

const bootstrap = () => {
    return platformBrowserDynamic([{ provide: DCAR_APP_CONFIG, useValue: environment }]).bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    });
};

if (environment.hmr) {
    // @ts-expect-error: TODO: Remove ignore when types are fixed
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error('HMR is not enabled for webpack-dev-server! Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap().catch((err) => console.error(err));
}
